export { default } from './WorkspaceFilesSection';
